import type {ScribeArtifact} from '@github-ui/scribe-artifacts'

export function shouldFetchIssueArtifacts(resourceId: number): boolean {
  return resourceId > 0
}

export function shouldShowArtifactsSection(artifacts: ScribeArtifact[] | undefined): boolean {
  return Boolean(artifacts?.length)
}

export function shouldShowCreateArtifactButton(artifacts: ScribeArtifact[] | undefined): boolean {
  return Array.isArray(artifacts) && artifacts.length === 0
}
